export default "__VITE_ASSET__DcQzO1q2__"